import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class ReadyController extends BridgeComponent {
  static component = "ready";

  connect() {
    super.connect();
    this.send("ready");
  }
}
